import { useState } from 'react';

interface CorporateIdentifiersData {
  rfc: string;
  cnbv_registration?: string;
}

interface CorporateIdentifiersStepProps {
  initialData?: Partial<CorporateIdentifiersData>;
  onSubmit: (data: CorporateIdentifiersData) => void;
  onBack: () => void;
  isSubmitting?: boolean;
}

const inputClass =
  'w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent';
const labelClass = 'block text-sm font-medium text-gray-700 mb-1';

export const CorporateIdentifiersStep: React.FC<CorporateIdentifiersStepProps> = ({
  initialData,
  onSubmit,
  onBack,
  isSubmitting = false,
}) => {
  const [form, setForm] = useState<CorporateIdentifiersData>({
    rfc: initialData?.rfc ?? '',
    cnbv_registration: initialData?.cnbv_registration ?? '',
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit(form);
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <label htmlFor="rfc" className={labelClass}>
            RFC *
          </label>
          <input
            className={inputClass}
            value={form.rfc}
            onChange={e => setForm(prev => ({ ...prev, rfc: e.target.value.toUpperCase() }))}
            placeholder="XAXX010101000"
            maxLength={13}
            required
          />
          <p className="text-xs text-gray-400 mt-1">
            Formato: 12 caracteres (persona moral) o 13 (persona física)
          </p>
        </div>

        <div>
          <label htmlFor="cnbvRegistration" className={labelClass}>
            Número de registro CNBV (opcional)
          </label>
          <input
            className={inputClass}
            value={form.cnbv_registration ?? ''}
            onChange={e => setForm(prev => ({ ...prev, cnbv_registration: e.target.value }))}
          />
        </div>
      </div>

      <div className="flex justify-between pt-2">
        <button
          type="button"
          onClick={onBack}
          className="px-6 py-2 text-sm text-gray-600 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
        >
          Anterior
        </button>
        <button
          type="submit"
          disabled={isSubmitting}
          className="px-6 py-2 text-sm font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700 transition-colors disabled:opacity-60"
        >
          {isSubmitting ? 'Guardando...' : 'Siguiente'}
        </button>
      </div>
    </form>
  );
};
